module.exports = __webpack_public_path__ + "img/Onboarding-Icon.9055e821.svg";